import ApiInstance from './instance'
import {
  URL_MAPPING,
  IChainsFilterDTO,
  ICreateChainDTO,
  IChainsResponseDTO,
  IChain,
  IAdminTask,
  EAdminTaskStatus,
  EOnboardingMilestoneStatus,
  IOnboarding
} from '@zunta/configurations'

const { chain: chainUrls } = URL_MAPPING

export default class ChainApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  createChain (data: ICreateChainDTO) {
    return this.instance.doPost(`${chainUrls.prefix}${chainUrls.createChain.path}`, data)
  }

  createOnboardingChain (data: any) {
    return this.instance.doPost(`${chainUrls.prefix}/createOnboardingChain`, { data })
  }
  updateOnboardingChain (chainId: number | string, data: any) {
    return this.instance.doPost(`${chainUrls.prefix}/updateOnboardingChain/${chainId}`, { data })
  }
  getChainsList (query: IChainsFilterDTO): Promise<IChainsResponseDTO> {
    return this.instance.doGet(`${chainUrls.prefix}${chainUrls.chainList.path}`, query)
  }
  getChain (id: string | number, relations: string[] = []): Promise<IChain> {
    return this.instance.doGet(`${chainUrls.prefix}${chainUrls.getChain.path}/${id}`, {
      relations: relations.join(',')
    })
  }
  residentCanEnterChain (residentId: string | number): Promise<boolean> {
    return this.instance.doGet(`${chainUrls.prefix}/residentCanEnterChain/resident/${residentId}`)
  }

  updateChain (id: number, data: Partial<IChain>) {
    return this.instance.doPut(`${chainUrls.prefix}${chainUrls.updateChain.path}/${id}`, data)
  }

  deleteChain (id: number) {
    return this.instance.doDelete(`${chainUrls.prefix}${chainUrls.deleteChain.path}/${id}`)
  }
  changeAllowToViewSystem (id: number | string, AllowToViewSystem: boolean) {
    return this.instance.doPut(`${chainUrls.prefix}/changeAllowToViewSystem/${id}`, { AllowToViewSystem })
  }
  updateStatus (id: number, status: string) {
    return this.instance.doPut(`${chainUrls.prefix}${chainUrls.updateStatus.path}/${id}`, { status })
  }
  getChainComments (id: number | string) {
    return this.instance.doGet(`${chainUrls.prefix}/chainComments/${id}/getAll`)
  }
  changeChainCommentPin (commentId: number, pin: boolean) {
    return this.instance.doPatch(`${chainUrls.prefix}/chainComments/${commentId}/change-pin`, { pin })
  }
  addChainComment (id: number | string, data: { text: string, baseComment: number | null }) {
    return this.instance.doPost(`${chainUrls.prefix}/chainComments/${id}/add`, data)
  }
  removeChainComment (id: number | string) {
    return this.instance.doDelete(`${chainUrls.prefix}/chainComments/${id}/remove`)
  }
  updateChainComment (id: number | string, text: string) {
    return this.instance.doPatch(`${chainUrls.prefix}/chainComments/${id}/update`, { text })
  }

  updateFacilitiesData (chainId: number) {
    return this.instance.doGet(`/facilities/updateFacilitiesData/${chainId}`)
  }

  checkSftpUser (username: string) {
    return this.instance.doGet(`/${chainUrls.prefix}/checkSftpUser`, { username })
  }

  createSftpUser (username: string, token: string) {
    return this.instance.doGet(`/${chainUrls.prefix}/createSftpUser`, { username, token })
  }
}
